import { GetExtension } from "./GetExtension";

export function IsBackgroundFile(fileName) {
  var fileExt = GetExtension(fileName);
  var isOC5master = fileExt == "oc5m" || fileExt == "ocb";
  return isOC5master;
}
